// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d9eb82b2","952":"7879524e"}[chunkId] + ".chunk.js";
};